import { SupportedLanguage } from '@app/utils/constants/supported-languages';

export const TALKJS_LOCALE_MAP: Partial<Record<SupportedLanguage, string>> = {
  [SupportedLanguage.ZhHans]: 'zh-CN',
  [SupportedLanguage.ZhHant]: 'zh-TW',
};
